module.exports = require("@material-ui/core/CircularProgress");